import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("circle", {
  cx: "12",
  cy: "12",
  r: "12",
  fill: "white"
}, null, -1)
const _hoisted_3 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
    color?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveIcon',
  props: {
    color: { default: "#F43841" }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("path", {
      d: "M3.50893 3.50893C-1.16964 8.1875 -1.16964 15.8125 3.50893 20.4911C8.18751 25.1696 15.8125 25.1696 20.491 20.4911C25.1697 15.8125 25.1697 8.1875 20.491 3.50893C15.8125 -1.16964 8.18751 -1.16964 3.50893 3.50893ZM16.0332 9.24039L13.2736 12L16.0332 14.7596C16.3814 15.1077 16.3814 15.6851 16.0332 16.0333C15.6851 16.3814 15.1078 16.3814 14.7595 16.0333L11.9999 13.2737L9.2404 16.0333C8.89226 16.3814 8.31487 16.3814 7.96674 16.0333C7.6186 15.6851 7.6186 15.1077 7.96674 14.7596L10.7263 12L7.96674 9.24039C7.6186 8.89226 7.6186 8.31487 7.96674 7.96673C8.31487 7.6186 8.89226 7.6186 9.2404 7.96673L11.9999 10.7263L14.7595 7.96673C15.1078 7.6186 15.6851 7.6186 16.0332 7.96673C16.3814 8.31487 16.3814 8.89226 16.0332 9.24039Z",
      fill: props.color
    }, null, 8, _hoisted_3)
  ]))
}
}

})